/**
 * Keeps add-on lines tied to the drink they belong to.
 *
 * An add-on carries a hidden _parent property naming its drink. Removing the
 * drink has to take its add-ons with it, or the shopper is left paying for
 * loose syrup they cannot order on its own.
 *
 * Runs ahead of the theme's own cart handler, in the capture phase, so the
 * whole group goes in one request rather than the drink leaving first and the
 * add-ons being re-rendered as orphans.
 */

const ROOT = () => window.Shopify?.routes?.root ?? '/';

/** Every cart line currently on the page, as rows. */
function rows() {
  return [...document.querySelectorAll('[data-key]')];
}

/** The keys of the add-on lines belonging to a drink row. */
function childKeysOf(row) {
  const title = row.dataset.menuParentTitle;
  if (!title) return [];
  return rows()
    .filter((other) => other.dataset.menuAddonOf === title)
    .map((other) => other.dataset.key)
    .filter(Boolean);
}

/** Removes several lines in a single cart update. */
async function removeLines(keys) {
  const updates = {};
  for (const key of keys) updates[key] = 0;

  const response = await fetch(`${ROOT()}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ updates }),
  });

  if (!response.ok) throw new Error(`Cart update failed: ${response.status}`);
  return response.json();
}

document.addEventListener(
  'click',
  (event) => {
    const control = event.target.closest(
      'a[href*="/cart/change"], button[name="remove"], [data-cart-remove], .cart-items__remove-button'
    );
    if (!control) return;

    const row = control.closest('[data-key]');
    if (!row) return;

    const children = childKeysOf(row);
    if (!children.length) return; // nothing attached, let the theme handle it

    // Take the group out together.
    event.preventDefault();
    event.stopPropagation();

    removeLines([row.dataset.key, ...children])
      .then(() => window.location.reload())
      .catch((error) => {
        console.warn('[menu-cart]', error);
        window.location.href = `${ROOT()}cart`;
      });
  },
  true
);